<style lang="scss"  scoped>

</style>

<template>
    <img :width="width" :class="[classes, {'invert' : theme != themeProp}]" alt="icona" :src="src + theme + '.svg'"/>
</template>
<script>

export default {
    props: ['themeProp', 'classes', 'width', 'src'],
    data: function () {
        return {
            message: '',
            transform: '',
            theme: this.themeProp,
            theme_memo: this.themeProp,
        };
    },
    mounted() {

        if(this.themeProp.split('-').length > 1) {
            this.theme = this.findBreakpointTheme();
            this.theme_memo = this.theme;
            this.$eventHub.$emit('themeChange', this.theme);
        }

        if(this.themeProp.split('_').length > 1) {
            this.theme = this.themeProp.split('_')[1];
            this.theme_memo = this.theme;
            this.separated_colors = true;
        }

        this.$eventHub.$on('themeChange', (payload) => {
            this.theme = payload;
            this.theme_memo = this.theme;
        });

        this.$eventHub.$on('menuIsOpen', (payload) => {
            if(payload.open) {
                let time = payload.mobile ? 150 : 10
                setTimeout(() => {
                    this.theme = 'dark';
                }, time)
                return
            }
            let time = payload.mobile ? 150 : 450
            setTimeout(() => {
                this.theme = this.theme_memo;
            }, time)
        });
    },
    methods: {
        findBreakpointTheme() {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let res = null;
            let themes = this.themeProp.split('-');
            if (vw < 576){
                res = 0;
            }else if (vw >= 576 && vw < 768) {
                res = 1;
            }else if (vw >= 768 && vw < 992) {
                res = 2;
            }else if (vw >= 992 && vw < 1199) {
                res = 3;
            }else if (vw >= 1200) {
                res = 4;
            }
            return themes[res];
        },
    },
    beforeDestroy() {
        this.$eventHub.$off('menuIsOpen');
    },
}
</script>
